<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">
                Добавить регион
            </div>
        </div>
    </div>

    <div class="inform col-md-4 col-12">
        <div class="form-row">
            <div class="col-md-12">
                <label for="reg-name_region">Название региона</label>
                <input type="text" class="form-control" id="reg-name_region" v-model="formData.name" placeholder="Введите название региона">
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12">
                <label for="reg-code">Код региона</label>
                <input type="text" class="form-control" id="reg-code" v-model="formData.code" placeholder="Введите код региона">
            </div>
        </div>
        <input type="button" class="btn btn-success" v-on:click="createRegion()" value="Сохранить">
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>
</template>

<script>
import Region from "../../../../models/Region";

export default {
    name: "RegionCreateComponent",
    props: {
        route_back: String,
        route_create: String
    },
    data: function () {
        return {
            region: new Region({
                route_create: this.route_create
            }),
            clients: [],
            formData: {
                name: '',
                code: ''
            }
        }
    },
    methods: {
        createRegion: async function () {
            let result = await this.region.create(this.formData);
            if (result) {
                window.location.href = this.route_back;
            }
            else {
                console.log('error: create_city');
            }
        }
    },
    mounted() {
    }
}
</script>

<style scoped>

</style>
